import ConditionalRender from '../../../components/ConditionalRender';
import { TimeSlot } from '../../../types/model';
import BasicItems from './BasicItems';
import Selectable from './Selectable';

type PropsType = {
  selectable: boolean;
  timeslots: Array<TimeSlot>;
  onSelect: Function;
  value: TimeSlot;
  timeZone: string;
  registrationRequired: boolean;
};

const AvailableTimeSlots = ({
  timeslots,
  onSelect,
  selectable,
  timeZone,
  registrationRequired,
}: PropsType) => {
  return (
    <ConditionalRender
      predicate={selectable}
      fallback={
        <BasicItems
          timeslots={timeslots}
          timeZone={timeZone}
          registrationRequired={registrationRequired}
        />
      }
    >
      <Selectable
        timeSlots={timeslots}
        onSelect={onSelect}
        timeZone={timeZone}
      />
    </ConditionalRender>
  );
};

export default AvailableTimeSlots;
